import Entity from "../../../class/abstract/Entity";

class Notification extends Entity {
    account_id = null;
    item_id = null;
    read = null;
    identifier = null;
    message = null;
    link = null;

    constructor(datas = {}) {
        super(datas);
        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                switch(key) {
                    default:
                        Reflect.set(this, key, datas[key]);
                        break;
                }
            }
        }
    }
}

export default Notification;